(function () {
  'use strict';
  if (window.__bfCampaignLoaded) return;
  window.__bfCampaignLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function Campaign(root) {
    this.root = root;
    this.start = Date.parse(root.dataset.start || '');
    this.end = Date.parse(root.dataset.end || '');
    this.early = root.dataset.early === 'true';
    this.listeners = [];
    this.tickers = [];
    this.timer = null;
  }

  Campaign.prototype.compute = function (now) {
    if (!Number.isNaN(this.end) && now >= this.end) return 'ended';
    if (this.early) return 'live';
    if (!Number.isNaN(this.start) && now >= this.start) return 'live';
    return 'upcoming';
  };

  Campaign.prototype.onChange = function (fn) {
    this.listeners.push(fn);
  };

  Campaign.prototype.onTick = function (fn) {
    this.tickers.push(fn);
  };

  Campaign.prototype.tick = function () {
    var root = this.root;
    var now = Date.now();
    var state = this.compute(now);
    var prev = root.dataset.state;

    if (state !== prev) {
      root.dataset.state = state;
      this.listeners.forEach(function (fn) {
        fn(state, prev);
      });
    }
    if (state === 'ended') {
      this.stop();
      return;
    }

    this.tickers.forEach(function (fn) {
      fn(state, now);
    });

    var target = state === 'upcoming' ? this.start : this.end;
    if (Number.isNaN(target)) return;
    var diff = Math.max(0, Math.floor((target - now) / 1000));
    var d = Math.floor(diff / 86400);
    var h = Math.floor((diff % 86400) / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;

    setDigit(root, '[data-bf-days]', pad(d));
    setDigit(root, '[data-bf-hours]', pad(h));
    setDigit(root, '[data-bf-minutes]', pad(m));
    setDigit(root, '[data-bf-seconds]', pad(s));
    root.classList.toggle('is-final-hour', state === 'upcoming' && diff < 3600);
    var compact = (d > 0 ? d + 'z ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    setText(root, '[data-bf-compact]', compact);
  };

  Campaign.prototype.run = function () {
    var self = this;
    this.tick();
    this.timer = setInterval(function () {
      self.tick();
    }, 1000);
  };

  Campaign.prototype.stop = function () {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  };

  function setDigit(root, selector, value) {
    root.querySelectorAll(selector).forEach(function (el) {
      if (el.textContent === value) return;
      var first = el.textContent === '00' && !el.dataset.bfSeen;
      el.textContent = value;
      el.dataset.bfSeen = '1';
      if (reduceMotion || first) return;
      el.classList.remove('is-tick');
      void el.offsetWidth;
      el.classList.add('is-tick');
    });
  }

  function setText(root, selector, value) {
    root.querySelectorAll(selector).forEach(function (el) {
      if (el.textContent !== value) el.textContent = value;
    });
  }

  function initHero(root) {
    if (root.dataset.bfReady === 'true') return;
    root.dataset.bfReady = 'true';

    var campaign = new Campaign(root);
    var designMode = root.hasAttribute('data-design-mode');
    var stage = root.querySelector('[data-bfx-stage]');
    var img = root.querySelector('[data-bfx-img]');
    var clipLines = root.querySelectorAll('[data-bfx-clip]');
    var sticky = root.querySelector('[data-bf-sticky]');
    var tanks = Array.prototype.slice.call(root.querySelectorAll('[data-bfx-tank]'));
    var tankRow = root.querySelector('[data-bfx-tanks]');
    var tankNav = root.querySelector('[data-bfx-tanks-nav]');
    var tankPrev = root.querySelector('[data-bfx-tanks-prev]');
    var tankNext = root.querySelector('[data-bfx-tanks-next]');
    var tankPos = [];
    var stageSize = { w: 1, h: 1 };
    var beamPx = parseFloat(getComputedStyle(root).getPropertyValue('--bfx-beam')) || 260;
    var tourIndex = -1;
    var lastTour = 0;
    var raf = null;
    var visible = true;

    function measureTanks() {
      if (!stage || !tanks.length) return;
      var sr = stage.getBoundingClientRect();
      var rr = tankRow ? tankRow.getBoundingClientRect() : sr;
      stageSize.w = sr.width || 1;
      stageSize.h = sr.height || 1;
      tankPos = tanks.map(function (tank) {
        var g = tank.querySelector('.bfx-tank__glass') || tank;
        var r = g.getBoundingClientRect();
        return {
          x: (r.left + r.width / 2 - sr.left) / stageSize.w,
          y: (r.top + r.height / 2 - sr.top) / stageSize.h,
          seen: r.left >= rr.left - 2 && r.right <= rr.right + 2,
        };
      });
    }

    function updateNav() {
      if (!tankRow || !tankNav) return;
      var max = tankRow.scrollWidth - tankRow.clientWidth;
      tankNav.hidden = max <= 4;
      if (tankPrev) tankPrev.disabled = tankRow.scrollLeft <= 4;
      if (tankNext) tankNext.disabled = tankRow.scrollLeft >= max - 4;
    }

    function stepTanks(dir) {
      if (!tankRow || !tanks.length) return;
      var w = tanks[0].getBoundingClientRect().width || 270;
      var gap = parseFloat(getComputedStyle(tankRow).columnGap) || 16;
      var per = Math.max(1, Math.floor((tankRow.clientWidth + gap) / (w + gap)));
      tankRow.scrollBy({ left: dir * per * (w + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (tankPrev) tankPrev.addEventListener('click', function () {
      stepTanks(-1);
    });
    if (tankNext) tankNext.addEventListener('click', function () {
      stepTanks(1);
    });

    function updateTankLinks(state) {
      tanks.forEach(function (tank) {
        var link = tank.querySelector('.bfx-tank__link');
        if (!link) return;
        var href = state === 'live' || tank.classList.contains('is-open') ? link.dataset.hrefLive : link.dataset.hrefUpcoming;
        if (href) link.setAttribute('href', href);
        if (state !== 'upcoming') tank.classList.remove('is-lit');
      });
    }

    function lightTanks() {
      if (!tankPos.length) return;
      var limit = beamPx * 0.45;
      tankPos.forEach(function (pos, i) {
        var dx = (pos.x - current.x) * stageSize.w;
        var dy = (pos.y - current.y) * stageSize.h;
        var lit = Math.sqrt(dx * dx + dy * dy) < limit;
        if (tanks[i].classList.contains('is-lit') !== lit) tanks[i].classList.toggle('is-lit', lit);
      });
    }

    campaign.onChange(function (state, prev) {
      if (state === 'live' && prev === 'upcoming' && !reduceMotion) {
        root.classList.add('is-lighting-up');
        setTimeout(function () {
          root.classList.remove('is-lighting-up');
        }, 1200);
      }
      if (state === 'ended' && !designMode) {
        var wrapper = root.closest('.shopify-section') || root;
        wrapper.hidden = true;
        destroy();
      }
      updateSticky();
      updateTankLinks(state);
    });

    function alignClip() {
      if (!root.classList.contains('bfx--cutout') || !img || !stage) return;
      var src = img.currentSrc || img.src;
      var iw = img.naturalWidth;
      var ih = img.naturalHeight;
      if (!src || !iw || !ih) return;
      var sr = stage.getBoundingClientRect();
      var scale = Math.max(sr.width / iw, sr.height / ih);
      var cw = iw * scale;
      var ch = ih * scale;
      var pos = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
      var px = parseFloat(pos[0]) / 100;
      var py = parseFloat(pos[1] || pos[0]) / 100;
      if (Number.isNaN(px)) px = 0.5;
      if (Number.isNaN(py)) py = 0.5;
      var cx = (sr.width - cw) * px;
      var cy = (sr.height - ch) * py;
      clipLines.forEach(function (line) {
        var r = line.getBoundingClientRect();
        line.style.backgroundImage = 'url("' + src + '")';
        line.style.backgroundSize = cw + 'px ' + ch + 'px';
        line.style.backgroundPosition = cx - (r.left - sr.left) + 'px ' + (cy - (r.top - sr.top)) + 'px';
        line.classList.add('is-clipped');
      });
    }

    var resizeObs = null;
    if (img) {
      if (img.complete && img.naturalWidth) alignClip();
      img.addEventListener('load', alignClip);
    }
    function onLayout() {
      alignClip();
      measureTanks();
      updateNav();
    }
    if (stage && 'ResizeObserver' in window) {
      resizeObs = new ResizeObserver(onLayout);
      resizeObs.observe(stage);
      if (tankRow) resizeObs.observe(tankRow);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(onLayout);
    if (tankRow) {
      tankRow.addEventListener(
        'scroll',
        function () {
          measureTanks();
          updateNav();
        },
        { passive: true }
      );
    }
    measureTanks();
    updateNav();

    var target = { x: 0.5, y: 0.45 };
    var current = { x: 0.5, y: 0.45 };
    var lastInput = 0;

    function setTarget(x, y) {
      var r = stage.getBoundingClientRect();
      target.x = Math.min(1, Math.max(0, (x - r.left) / r.width));
      target.y = Math.min(1, Math.max(0, (y - r.top) / r.height));
      lastInput = performance.now();
      root.classList.add('has-interacted');
    }

    if (stage) {
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'touch') setTarget(e.clientX, e.clientY);
      });
      ['touchstart', 'touchmove'].forEach(function (type) {
        stage.addEventListener(
          type,
          function (e) {
            if (e.touches[0]) setTarget(e.touches[0].clientX, e.touches[0].clientY);
          },
          { passive: true }
        );
      });
    }

    function loop(now) {
      raf = null;
      if (!visible || root.dataset.state !== 'upcoming') return;
      if (!reduceMotion && now - lastInput > 2500) {
        var onScreen = tankPos.filter(function (p, i) {
          return p.seen && p.x > 0.02 && p.x < 0.98 && !tanks[i].classList.contains('is-open');
        });
        if (onScreen.length) {

          if (now - lastTour > 2200) {
            tourIndex = (tourIndex + 1) % onScreen.length;
            lastTour = now;
          }
          var p = onScreen[tourIndex % onScreen.length];
          target.x = p.x;
          target.y = p.y;
        } else {
          var t = now / 1000;
          target.x = 0.5 + Math.sin(t * 0.45) * 0.32;
          target.y = 0.48 + Math.sin(t * 0.7 + 1.2) * 0.26;
        }
      }
      var ease = reduceMotion ? 1 : 0.06;
      current.x += (target.x - current.x) * ease;
      current.y += (target.y - current.y) * ease;
      root.style.setProperty('--bfx-x', (current.x * 100).toFixed(2) + '%');
      root.style.setProperty('--bfx-y', (current.y * 100).toFixed(2) + '%');
      lightTanks();
      raf = requestAnimationFrame(loop);
    }

    function startLoop() {
      if (!raf && visible && root.dataset.state === 'upcoming') raf = requestAnimationFrame(loop);
    }

    var heroVisible = true;
    var footerVisible = false;

    function updateSticky() {
      if (!sticky) return;
      var show = !heroVisible && !footerVisible && root.dataset.state !== 'ended';
      sticky.classList.toggle('is-visible', show);
    }

    if ('IntersectionObserver' in window && stage) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        heroVisible = visible;
        updateSticky();
        startLoop();
      }).observe(stage);

      var footer = document.querySelector('.footer, footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          updateSticky();
        }).observe(footer);
      }
    }

    function destroy() {
      campaign.stop();
      if (raf) cancelAnimationFrame(raf);
      if (resizeObs) resizeObs.disconnect();
      visible = false;
    }
    root._bfDestroy = destroy;

    tanks.forEach(function (tank) {
      var at = Date.parse(tank.dataset.reveal || '');
      if (!Number.isNaN(at)) tank._revealAt = at;
    });

    campaign.onTick(function (state, now) {
      if (state !== 'upcoming') return;
      tanks.forEach(function (tank) {
        if (!tank._revealAt || now < tank._revealAt || tank.classList.contains('is-open')) return;
        tank.classList.add('is-open');
        tank.classList.remove('is-lit');
        var openLink = tank.querySelector('.bfx-tank__link');
        if (openLink && openLink.dataset.hrefLive) openLink.setAttribute('href', openLink.dataset.hrefLive);
        if (!reduceMotion) {
          tank.classList.add('is-opening');
          setTimeout(function () {
            tank.classList.remove('is-opening');
          }, 950);
        }
      });
    });

    initExit(root, designMode);

    campaign.run();
    startLoop();
  }

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
    return null;
  }

  function session(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
    return null;
  }

  function initExit(root, designMode) {
    var exitEl = root.querySelector('[data-bfx-exit]');
    var rootStyle = getComputedStyle(root);
    var shownThisPage = false;

    root.querySelectorAll('.bfx__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        store('bfxSubscribed', '1');
      });
    });
    if (root.querySelector('.bfx__form-success')) store('bfxSubscribed', '1');

    if (!exitEl || designMode) return;
    var desktop = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!desktop) return;

    ['--bfx-accent', '--bfx-accent-rgb', '--bfx-font', '--bfx-weight'].forEach(function (name) {
      var value = rootStyle.getPropertyValue(name);
      if (value) exitEl.style.setProperty(name, value.trim());
    });
    document.body.appendChild(exitEl);

    var exitForm = exitEl.querySelector('form');
    if (exitForm) {
      exitForm.addEventListener('submit', function () {
        store('bfxSubscribed', '1');
      });
    }

    var lastFocus = null;
    var armed = false;
    setTimeout(function () {
      armed = true;
    }, 1200);

    function close() {
      exitEl.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () {
        exitEl.hidden = true;
      }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    function open() {
      shownThisPage = true;
      session('bfxExitShown', '1');
      lastFocus = document.activeElement;
      exitEl.hidden = false;
      requestAnimationFrame(function () {
        exitEl.classList.add('is-open');
      });
      document.addEventListener('keydown', onKey);
      var input = exitEl.querySelector('input[type="email"]');
      if (input) setTimeout(function () {
        input.focus();
      }, 320);
    }

    exitEl.querySelectorAll('[data-bfx-exit-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    function maybeOpen() {
      if (!armed || shownThisPage) return;
      if (root.dataset.state !== 'upcoming') return;
      if (session('bfxExitShown') || store('bfxSubscribed')) return;
      open();
    }

    document.documentElement.addEventListener('mouseleave', function (e) {
      if (e.clientY < 60) maybeOpen();
    });

    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY < 60) maybeOpen();
    });

    var lastY = null;
    var lastT = 0;
    document.addEventListener(
      'mousemove',
      function (e) {
        var t = performance.now();
        if (lastY !== null && e.clientY < 14) {
          var speed = (lastY - e.clientY) / Math.max(1, t - lastT);
          if (speed > 0.35) maybeOpen();
        }
        lastY = e.clientY;
        lastT = t;
      },
      { passive: true }
    );
  }

  function initBar(root) {
    if (root.dataset.bfReady === 'true') return;
    root.dataset.bfReady = 'true';
    var campaign = new Campaign(root);
    var docStyle = document.documentElement.style;
    var sticky = root.hasAttribute('data-bfbar-sticky');
    var sizeObs = null;

    function setHeight() {
      if (!sticky) return;
      var wrapper = root.closest('.shopify-section') || root;
      docStyle.setProperty('--bfbar-h', (wrapper.hidden ? 0 : wrapper.offsetHeight) + 'px');
    }

    if (sticky) {
      setHeight();
      if ('ResizeObserver' in window) {
        sizeObs = new ResizeObserver(setHeight);
        sizeObs.observe(root);
      } else {
        window.addEventListener('resize', setHeight);
      }
    }

    campaign.onChange(function (state) {
      if (state === 'ended') {
        var wrapper = root.closest('.shopify-section') || root;
        wrapper.hidden = true;
        var hideOld = document.getElementById('bf-hide-topbar');
        if (hideOld) hideOld.remove();
        var stickyStyle = document.getElementById('bf-bar-sticky');
        if (stickyStyle) stickyStyle.remove();
        docStyle.setProperty('--bfbar-h', '0px');
        if (sizeObs) sizeObs.disconnect();
      }
    });
    root._bfDestroy = function () {
      campaign.stop();
      if (sizeObs) sizeObs.disconnect();
    };
    campaign.run();
  }

  function initAll(scope) {
    var el = scope || document;
    el.querySelectorAll('[data-bfx]').forEach(initHero);
    el.querySelectorAll('[data-bfbar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-bfx], [data-bfbar]').forEach(function (el) {
      if (el._bfDestroy) el._bfDestroy();
    });
  });
})();
